module.exports = __webpack_public_path__ + "static/media/Sport_7_t.7cc6f8fb.jpg";